import { Car, Leaf, Sparkles, Trees, Waves, Wine } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useContent } from "@/context/ContentContext";

const ICONS = { leaf: Leaf, wine: Wine, sparkles: Sparkles, waves: Waves, trees: Trees, car: Car };

export default function Storia() {
  const { storia, images } = useContent();

  return (
    <section id="trattoria" data-testid="storia-section" className="py-24 lg:py-32 bg-sand-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="text-xs font-semibold tracking-[0.2em] uppercase text-terracotta-600 mb-4 block">
                {storia.overline}
              </span>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight text-olive-900 leading-tight">
                {storia.heading}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 text-base md:text-lg font-light text-stone-600 leading-relaxed">
                {storia.p1}
              </p>
              <p className="mt-6 text-base md:text-lg font-light text-stone-600 leading-relaxed">
                {storia.p2}
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 gap-4 lg:gap-6">
            <Reveal delay={0.1} className="col-span-2 sm:col-span-1 sm:mt-12">
              <img
                src={images.interior}
                alt="La sala interna della trattoria"
                className="w-full aspect-[4/5] object-cover"
              />
            </Reveal>
            <Reveal delay={0.25} className="col-span-2 sm:col-span-1">
              <img
                src={images.cellar}
                alt="La cantina dei vini"
                className="w-full aspect-[4/5] object-cover"
              />
            </Reveal>
          </div>
        </div>

        <div className="mt-24 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-14">
          {storia.features.map((f, i) => {
            const Icon = ICONS[f.icon] || Leaf;
            return (
              <Reveal key={f.title} delay={0.08 * i}>
                <Icon className="w-6 h-6 text-terracotta-600" strokeWidth={1.5} aria-hidden="true" />
                <h3 className="mt-4 font-serif text-xl sm:text-2xl font-medium text-stone-800">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm md:text-base font-light text-stone-600 leading-relaxed">
                  {f.text}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
